<template>
    <div class="page t-container">
        <section class="t-mt-12 t-flex-col t-space-y-8 lg:t-space-y-0 lg:t-flex-row" role="main">
            <div class="t-flex t-flex-col t-space-y-8 lg:t-w-full lg:t-mr-8">
                    <el-card v-loading="bookingsLoadStatus">
                    <div v-if="noLocations" style="text-align: center; margin-bottom: 10px">
                        <h5>{{ locationsText }}</h5>
                        <hr />
                    </div>

                    <div v-if="!bookingsLoadStatus" slot="header">
                        <h5>
                            Manifest: Pickups from {{ headerLocation.name }},
                            {{ headerLocation.address.data.street_number }}
                            {{ headerLocation.address.data.street_name }},
                            {{ headerLocation.address.data.suburb }}
                            {{ headerLocation.address.data.region }}
                        </h5>
                    </div>
                    <div v-if="!bookingsLoadStatus" class="t-pt-0">
                        <div>
                            <div class="t-mb-2">
                                <el-select
                                    v-model="form.bookingStatusOrder"
                                    style="width: 15%"
                                    multiple
                                    placeholder="Select booking status"
                                    class="t-mr-1"
                                >
                                    <el-option
                                        v-for="bookingStatus in bookingStatuses"
                                        :key="bookingStatus.value"
                                        :label="bookingStatus.label"
                                        :value="bookingStatus.value"
                                    >
                                    </el-option>
                                </el-select>

                                <el-select
                                    v-model="form.location"
                                    placeholder="Select"
                                    :loading="bookingsLoadStatus"
                                    class="t-mr-1"
                                >
                                    <el-option
                                        v-for="pickupLocation in pickupLocations"
                                        :key="pickupLocation.id"
                                        :label="pickupLocation.name"
                                        :value="pickupLocation.id"
                                    >
                                    </el-option>
                                </el-select>

                                <el-date-picker
                                    v-model="form.date"
                                    style="width: 25%"
                                    type="daterange"
                                    placeholder="Pick a day"
                                    :start-placeholder="defaultDate"
                                    :end-placeholder="defaultDate"
                                    unlink-panels
                                    range-separator="-"
                                    format="yy/MM/dd"
                                    value-format="yyyy-MM-dd"
                                >
                                </el-date-picker>

                                <el-button
                                    :disabled="bookingsLoadStatus"
                                    class="t-ml-1"
                                    type="primary"
                                    style="font-weight: bold"
                                    plain
                                    @click="filter()"
                                    >Search</el-button
                                >
                                <el-button
                                    :disabled="bookingsLoadStatus"
                                    type="text"
                                    class="t-ml-1"
                                    @click="load()"
                                    ><u style="font-weight: bold">Reset</u></el-button
                                >

                                <el-dropdown
                                    v-loading="manifestDownloading"
                                    split-button
                                    type="primary"
                                    :disabled="bookingsLoadStatus"
                                    class="t-ml-1 float-right"
                                    @click="exportTable(bookings, 'pdf')"
                                >
                                    <span>Export all as PDF</span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item @click.native="exportSelectedTable('pdf')"
                                            >Export selected as PDF</el-dropdown-item
                                        >
                                        <el-dropdown-item
                                            @click.native="exportTable(bookings, 'csv')"
                                            >Export all as CSV</el-dropdown-item
                                        >
                                        <el-dropdown-item @click.native="exportSelectedTable('csv')"
                                            >Export selected as CSV</el-dropdown-item
                                        >
                                        <el-dropdown-item @click.native="markAsPickedUpSelectedTable()"
                                            >Mark selected as picked up</el-dropdown-item
                                        >
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="
                            Object.keys(oldBookings).length === 0 &&
                                Object.keys(currentBookings).length === 0 &&
                                Object.keys(futureBookings).length === 0 &&
                                !bookingsLoadStatus
                        "
                    >
                        You have no bookings waiting to be picked up from this location.
                    </div>

                    <div v-if="!bookingsLoadStatus" class="t-mt-3">
                        <el-card
                            v-if="Object.keys(oldBookings).length != 0"
                            v-loading="bookingsLoadStatus"
                            class="t-mb-4"
                        >
                            <manifest-table
                                id="pastTable"
                                :bookings="oldBookings"
                                :title="'Past'"
                                @selected="handleSelectionChange"
                            ></manifest-table>
                        </el-card>

                        <el-card
                            v-if="Object.keys(currentBookings).length != 0"
                            v-loading="bookingsLoadStatus"
                            class="t-mb-4 box-card"
                        >
                            <manifest-table
                                id="currentTable"
                                :bookings="currentBookings"
                                :title="'Current'"
                                @selected="handleSelectionChange"
                            ></manifest-table>
                        </el-card>

                        <el-card
                            v-if="Object.keys(futureBookings).length != 0"
                            v-loading="bookingsLoadStatus"
                            class="t-mb-4"
                        >
                            <manifest-table
                                id="futureTable"
                                :bookings="futureBookings"
                                :title="'Future'"
                                @selected="handleSelectionChange"
                            ></manifest-table>
                        </el-card>
                    </div>
                </el-card>
            </div>
        </section>
    </div>
</template>

<script>
import ManifestTable from "./ManifestTable";

const bookingStatuses = [
    {
        value: 2,
        label: "Pending Acceptance"
    },
    {
        value: 3,
        label: "Booked"
    },
    {
        value: 4,
        label: "Picked up"
    },
    {
        value: 5,
        label: "Delivered"
    },
    {
        value: 9,
        label: "Cancelled"
    }
];

export default {
    name: "Manifest",
    components: { ManifestTable },
    data() {
        return {
            bookings: [],
            locations: [],
            bookingStatuses,
            form: {
                location: null,
                date: new Date(),
                bookingStatusOrder: [3]
            },
            loading: true,
            defaultLocation: false,
            locationLoading: true,
            selectedBookings: [],
            locationsText: "You have no locations please create a location and try again.",
            noLocations: false,
            manifestDownloading: false,
            bookingSelected: []
        };
    },
    computed: {
        headerLocation() {
            return this.$store.getters.getHeaderLocation;
        },
        pickupLocations() {
            return this.$store.getters.getPickupLocations;
        },
        bookingsLoadStatus() {
            return (
                this.$store.getters.getManifestBookingsLoadStatus === 1 ||
                this.$store.getters.getHeaderLocationLoadStatus === 1 ||
                this.$store.getters.getDefaultPickupLocationLoadStatus === 1
            );
        },
        manifestBookings() {
            return this.$store.getters.getManifestBookings;
        },
        currentBookings() {
            return this.$store.getters.getCurrentBookings;
        },
        futureBookings() {
            return this.$store.getters.getFutureBookings;
        },
        oldBookings() {
            return this.$store.getters.getOldBookings;
        },
        defaultPickupLocation() {
            return this.$store.getters.getDefaultPickupLocation;
        },
        defaultDate() {
            return new Date().toLocaleDateString();
        },
        hasBeenFiltered() {
            return this.$store.getters.getFiltered;
        }
    },
    created() {
        this.$store.dispatch("loadManifestBookings");
        this.$store.dispatch("loadPickupLocations");
        this.$store.dispatch("loadDefaultPickupLocation");
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            this.$store.dispatch("loadDefaultPickupLocation");
            this.$store.dispatch("loadManifestBookings");
            this.$store.dispatch("loadPickupLocations");
            this.clearData();
            this.loadDefaultLocation();
        },
        clearData() {
            this.selectedBookings = [];
            this.$store.commit("setFiltered", false);
            this.form.bookingStatusOrder = [3];
            this.form.date = new Date();
        },
        loadDefaultLocation() {
            this.$store.commit("setDefaultPickupLocationLoadStatus", 1);
            this.$store.commit("setHeaderLocationLoadStatus", 1);
            axios
                .get("/settings/locations/default-pickup")
                .then(response => {
                    this.form.location = response.data.data.id;
                    this.$store.commit("setHeaderLocation", response.data.data);
                    this.$store.commit("setDefaultPickupLocationLoadStatus", 2);
                    this.$store.commit("setHeaderLocationLoadStatus", 2);
                })
                .catch(response => {
                    //If no default location set it to their first one and reload the data
                    if (this.headerLocation == null && this.locations.length > 0) {
                        this.$store.commit("setHeaderLocation", this.locations[0]);
                        this.form.location = this.locations[0].id;
                    } else {
                        this.noLocations = true;
                    }
                    this.$store.commit("setDefaultPickupLocationLoadStatus", 3);
                    Event.$emit("severError");
                });
        },
        filter() {
            if (this.form.date != null) {
                const data = {
                    location: this.form.location,
                    date: this.form.date,
                    bookingStatus: this.form.bookingStatusOrder
                };

                this.$store.dispatch("filterBookings", data);
            }
        },
        exportTable(bookings, format) {
            this.manifestDownloading = true;
            axios
                .post("manifest/export", {
                    location: this.form.location,
                    date: this.form.date,
                    selected: false,
                    format: format,
                    filtered: this.hasBeenFiltered,
                    bookingStatus: this.form.bookingStatusOrder
                })
                .then(res => {
                    if (res.data != "") {
                        this.download(res.data, format);
                    }
                })
                .catch(res => {
                    Event.$emit("severError");
                    this.manifestDownloading = false;
                });
        },
        download(guid, format) {
            axios({
                url: "manifest/download/" + guid,
                method: "GET",
                responseType: "blob"
            }).then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                    "download",
                    this.headerLocation.name + " " + this.form.date + "." + format
                );
                document.body.appendChild(link);
                link.click();
                this.manifestDownloading = false;
            });
        },
        handleSelectionChange(selected, title) {
            var index = this.calcIndex(title);
            this.selectedBookings[index] = selected;
        },
        exportSelectedTable(format) {
            this.manifestDownloading = true;
            if (this.areBookingsSelected(this.selectedBookings)) {
                axios
                    .post("manifest/export", {
                        bookings: this.selectedBookings,
                        location: this.form.location,
                        date: this.form.date,
                        selected: true,
                        format: format,
                        bookingStatus: this.form.bookingStatusOrder
                    })
                    .then(res => {
                        if (res.data != "") {
                            this.download(res.data, format);
                        }
                    })
                    .catch(res => {
                        Event.$emit("severError");
                        // console.log(res);
                        this.manifestDownloading = false;
                    });
            } else {
                this.$message.error('Sorry, no bookings have been selected. Please tick to select the bookings to be included and then export. To export all bookings, click the Export all as PDF button.');
                this.manifestDownloading = false;
            }
        },
        markAsPickedUpSelectedTable() {
          this.manifestDownloading = true;

          this.selectedBookings.forEach((value, index) => {
              if (value !== undefined) {
                value.forEach((subvalue, index) => {
                  if (subvalue !== undefined) {
                    subvalue.forEach((subchildvalue, index) => {
                      this.bookingSelected.push(subchildvalue);
                    });
                  }
                })
              }
          });

          if (this.areBookingsSelected(this.selectedBookings)) {
            axios
              .post("manifest/mark-as-picked-up", {
                bookings: this.bookingSelected,
                update_time: this.form.date
              })
              .then(res => {
                if (res.data != "") {
                  this.manifestDownloading = false;
                  this.load();

                }
              })
              .catch(res => {
                Event.$emit("severError");
                // console.log(res);
                this.manifestDownloading = false;
              });
          } else {
            this.$message.error('Sorry, no bookings have been selected. Please tick to select the bookings to be included and then export. To export all bookings, click the Export all as PDF button.');
            this.manifestDownloading = false;
          }
        },
        getRowKey(row) {
            return row.id;
        },
        areBookingsSelected(bookings) {
            if (bookings.length > 0) {
                let length = 0;

                const titleId = [1, 2, 3];

                titleId.forEach(id => {
                    if (bookings[id] !== undefined) {
                        length += bookings[id]
                            .filter(booking => booking != null)
                            .map(thing => thing.length)
                            .reduce((a, b) => a + b, 0);
                    }
                });

                if (length > 0) {
                    return true;
                }
            }

            return false;
        },
        calcIndex(title) {
            switch (title) {
                case "Past":
                    return 1;
                case "Current":
                    return 2;
                case "Future":
                    return 3;
                default:
                    return 4;
            }
        }
    }
};
</script>

<style type="text/css" media="print">
@page {
    size: landscape;
}

div > div > div > div.el-card__body > div.mt-5 > div {
    width: 100% !important;
}
</style>
